/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';

import {
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
} from '@mui/icons-material';
import Pagination from 'react-js-pagination';
import { Table } from 'reactstrap';
import { toast } from 'react-toastify';

import { LoaderLista } from '~/components/Loaders';
import { symbolPriceFormatter } from '~/helpers/price';

import { FiltroRevendas } from '~/components/Filtros/FiltroRevendas';
import { TrStyled, SolicitarButtonStyled } from './styles';

export function ConsultaRevendas(props) {
	const { user, isMobile } = props;

	const {
		dataRevendas,
		getRevendas,
		setLoadingResumo,
		filtroPesquisa,
		setFiltroPesquisa,
		filtroOrder,
		setFiltroOrder,
		setLoadingRevenda,
		loadingRevenda,
		totalItemsRevendas,
		pagina,
		setPagina,
		postSolicitacao,
		getResumoWithResponse,
		setDataResumo
	} = props;

	function handlerPagination(page) {
		setPagina(page);
		getRevendas(pagina, 10, filtroPesquisa, filtroOrder).then(() => setLoadingRevenda(true));
	}

	useEffect(() => {
		handleViewRevendasGA4();
		getRevendas(pagina, 10, filtroPesquisa, filtroOrder).then(() => setLoadingRevenda(true));
	}, [filtroOrder, filtroPesquisa]);

	const SolicitaRevenda = (id) => {
		toast.success('Crédito Solicitado!')
		setLoadingResumo(false)

		postSolicitacao(id).then(
			getResumoWithResponse().then((res) => {
				setDataResumo(res.data)
			})
		)
	}

	function handleViewRevendasGA4() {
		ReactGA.event({
			category: "view_revendas_industria",
			action: "Aba Revendas Industria",
			label: "Visualizando Aba Revendas Industria",
		});
	}

	return (
		<>
			<FiltroRevendas
				user={user}
				setFiltroPesquisa={setFiltroPesquisa}
				setFiltroStatus={setFiltroOrder}
				filtroStatus={filtroOrder}
				setPagina={setPagina}
			/>
			<LoaderLista loading={!loadingRevenda} lista={dataRevendas}>
				<Table id="test-table-xls-button" responsive className="notranslate">
					<thead>
						<TrStyled>
							<th>ID</th>
							<th style={{ textAlign: 'left' }}>Revendas</th>
							<th>Crédito</th>
						</TrStyled>
					</thead>
					<tbody>
						{dataRevendas.map((item) => {
							return (
								<tr style={{ textAlign: 'center' }}>
									<td>{item.id}</td>
									<td style={{ textAlign: 'left' }}>{item.nome}</td>
									<>
										{item.descricao.toLowerCase() === 'aprovado' && <td>{symbolPriceFormatter(item.saldo)}</td>}

										{item.descricao.toLowerCase() === 'reprovado' && <td>--</td>}

										{(item.descricao.toLowerCase() === 'pendente' || item.descricao.toLowerCase() === '') &&
											<td>
												<SolicitarButtonStyled
													outline
													color="primary"
													disabled={item.descricao.toLowerCase() === 'pendente'}
													onClick={() => SolicitaRevenda(item.id)}>
													{item.descricao.toLowerCase() === 'pendente' ? 'SOLICITADO' : 'SOLICITAR'}
												</SolicitarButtonStyled>
											</td>
										}
									</>
									{/* <td>{symbolPriceFormatter(item.saldo)}</td> */}
								</tr>
							);
						})}
					</tbody>
				</Table>

				<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
					<Pagination
						activePage={pagina}
						totalItemsCount={totalItemsRevendas}
						onChange={(page) => handlerPagination(page)}
						prevPageText={<ChevronLeftOutlined />}
						nextPageText={<ChevronRightOutlined />}
						firstPageText={<FirstPageOutlined />}
						lastPageText={<LastPageOutlined />}
					/>
				</div>
			</LoaderLista>
		</>
	);
}
